var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CTabs',{staticClass:"nav-tabs-boxed",attrs:{"variant":"tabs"}},[_c('CTab',{attrs:{"title":"Motivos atendimento"}},[_c('MotivosAtendimento')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }